module.exports = __webpack_public_path__ + "3e726c2b6a59e6e4543c0a1534d93796.svg";